import { User } from 'common/types';

export enum ActionType {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
}

interface Login {
  type: ActionType.LOGIN;
  payload: {
    user: User;
  };
}

interface Logout {
  type: ActionType.LOGOUT;
}

export type Action = Login | Logout;
